module.exports = __webpack_public_path__ + "static/img/pic_city.1daa2cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/topPage/pic_city.png
// module id = Cuys
// module chunks = 0